import {
  Box,
  Button,
  CircularProgress,
  Container,
  Heading,
  HStack,
  IconButton,
  Skeleton,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useDisclosure,
  VStack,
  Breadcrumb,
  BreadcrumbItem,
  Stack,
} from "@chakra-ui/react";

//Components
import Header from "components/dashHeader";
import BreadcrumbLink from "components/BreadcrumbLink/BreadcrumbLink";
import Sidemenu from "components/sidemenu";
import Select from "components/Select/Select";
import { isEmpty, toUpper } from "lodash";
import { format, parseISO } from "date-fns";
import formatter from "util/formatter";

import { useHistory } from "react-router-dom";

import useTradeHistory from "hooks/useTradeHistory";
import { ReplayRounded } from "@material-ui/icons";
import {
  // DownloadIcon,
  ChevronRightIcon,
  ChevronLeftIcon,
} from "@chakra-ui/icons";

import DownloadTradeHistory from "components/Modals/p2p/DownloadTradeHistory";

import {
  Pagination,
  usePagination,
  PaginationPage,
  PaginationNext,
  PaginationPrevious,
  PaginationPageGroup,
  PaginationContainer,
  PaginationSeparator,
} from "@ajna/pagination";
import { useCallback, useEffect, useState } from "react";

import { clamp } from "util/utils";
import toPrecision from "util/toPrecision";
import UserPopover from "components/UserPopover/UserPopover";

const NoData = () => {
  return (
    <VStack p="100px" bg="white">
      <Text color="#bdbdbd">No listing found</Text>
    </VStack>
  );
};

const TradeHistory = (props) => {
  const history = useHistory();

  const { isOpen, onClose } = useDisclosure();

  const [totalTrades, setTotalTrades] = useState(0);

  // const userData = props.userData;

  /* Pagination */
  // constants
  const outerLimit = 1;
  const innerLimit = 1;

  const {
    pages,
    pagesCount,
    offset,
    currentPage,
    setCurrentPage,
    isDisabled,
    pageSize,
  } = usePagination({
    total: totalTrades,
    limits: {
      outer: outerLimit,
      inner: innerLimit,
    },
    initialState: {
      pageSize: 10,
      isDisabled: false,
      currentPage: 1,
    },
  });

  const { count, data, type, updateType, refetch, status } = useTradeHistory({
    limit: pageSize,
    page: currentPage,
  });

  console.log("TRADEs", data);

  useEffect(() => setTotalTrades(count), [count]);

  const tradeOwner = useCallback((trade) => {
    if (trade?.paymentStatus === "paid") return trade?.counterParty;

    if (trade?.adsType === "selling")
      return trade?.counterParties?.find((c) => c?.perspective === "buyer")
        ?.user;
    if (trade?.adsType === "buying")
      return trade?.counterParties?.find((c) => c?.perspective === "seller")
        ?.user;
  }, []);

  // handlers
  const handlePageChange = (nextPage) => {
    setCurrentPage(nextPage);
  };

  // const mapDetailPage = (ownerId, traderId) => (userId) => {
  //   const pageMap = {
  //     [traderId]: "session",
  //     [ownerId]: "order",
  //   };
  //   return pageMap[userId];
  // };

  const actions = [
    // { label: "All trades", value: "all" },
    { label: "Pending", value: "pending" },
    { label: "Cancelled", value: "cancelled" },
    { label: "In Dispute", value: "indispute" },
    { label: "Completed", value: "completed" },
  ];

  const statusMap = (status) => {
    const map = {
      open: "Pending",
      closed: "Completed",
      cancelled: "Cancelled",
      timeout: "Timedout",
      indispute: "In Dispute",
    };

    return map[status];
  };

  return (
    <Box
      __css={{
        "--color": "#4E4B66",
        "--borderColor": "#D9DBE9",
        "--focusColor": "#06c34491",
        "--primary": "#03A438",
      }}
    >
      <Sidemenu currentPage="P2P" logoutUser={props.logout} />
      <Header />

      <Box className="p2p">
        <Box
          className="p2p-container"
          p={["6em 0 !important", "6.5em 1.5em !important"]}
        >
          <Container
            maxW={["100%", "container.xl"]}
            p={["0", "1.5rem", "1rem"]}
          >
            <Box px={["28px", "0", "0"]}>
              <Heading fontSize="3xl">Trade History</Heading>

              <Breadcrumb separator={<ChevronRightIcon color="gray.500" />}>
                <BreadcrumbItem>
                  <BreadcrumbLink to="/dashboard/p2p">P2P</BreadcrumbLink>
                </BreadcrumbItem>

                <BreadcrumbItem isCurrentPage>
                  <BreadcrumbLink isCurrentPage href="#">
                    Trade History
                  </BreadcrumbLink>
                </BreadcrumbItem>
              </Breadcrumb>
            </Box>

            <Box mt="40px">
              <HStack
                bg="white"
                p={["30px 28px", "30px 28px", "10px 40px"]}
                justifyContent="space-between"
                borderRadius={["0", "0", "16px 16px 0 0"]}
                mb={["20px", "20px", "0"]}
                // d={["none", "none", "flex"]}
              >
                <HStack gridGap="30px" d={["none", "none", "flex"]}>
                  {actions?.map((action) => {
                    return (
                      <Button
                        color={action.value === type ? "black" : "#8c8aa1"}
                        fontSize="14px"
                        textDecoration="none !important"
                        variant="link"
                        onClick={() => {
                          updateType(action.value);
                          setCurrentPage(1);
                        }}
                        _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
                      >
                        {action.label}
                      </Button>
                    );
                  })}
                </HStack>

                <Select
                  d={["inline-block", "inline-block", "none"]}
                  ml="0 !important"
                  value={type}
                  onChange={(e) => {
                    console.log("status", type);
                    updateType(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  {actions.map((action, i) => (
                    <option key={`statuses-${i}`} value={action.value}>
                      {action.label}
                    </option>
                  ))}
                </Select>

                <HStack>
                  {/* <Button
                    leftIcon={<DownloadIcon />}
                    size="sm"
                    variant="ghost"
                    _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
                    onClick={onOpen}
                  >
                    Download
                  </Button> */}

                  <IconButton
                    onClick={refetch}
                    _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
                    size="xs"
                    aria-label="refetch"
                    icon={<ReplayRounded style={{ fontSize: "14px" }} />}
                  />

                  {status === "fetching" && (
                    <CircularProgress
                      ml="12px !important"
                      size="14px"
                      isIndeterminate
                      color="green"
                    />
                  )}
                </HStack>
              </HStack>
              {/* {!isEmpty(data) && ( */}
              <Table
                variant="solid"
                colorScheme="teal"
                bg="white"
                // borderRadius="16px"
                border="1px solid #D9DBE95f"
                overflow="hidden"
                d={["none", "none", "table"]}
              >
                {/* <TableCaption >
                  Imperial to metric conversion factors
                </TableCaption> */}
                <Thead bg="#F1F1F1">
                  <Tr pos="sticky" top="0" h="fit-content">
                    <Th py="20px">Name</Th>
                    <Th py="20px">Date Created</Th>
                    <Th>Type</Th>
                    <Th>Amount</Th>
                    <Th>Total Volume</Th>
                    <Th>Status</Th>
                    <Th></Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {data.map((trade, i) => (
                    <Tr
                      borderBottom={
                        i === data?.length - 1 ? "none" : "1px solid #D9DBE9"
                      }
                    >
                      <Td>
                        <Skeleton isLoaded={status !== "fetching"}>
                          <UserPopover user={tradeOwner(trade)} />
                          {/* <Button
                            px="0"
                            size="xs"
                            fontSize=".95em"
                            color="#3151AB"
                            lineHeight="16px"
                            _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
                            _hover={{
                              bg: "transparent",
                              shadow: "0 0 0 3px var(--focusColor)",
                            }}
                            _active={{
                              bg: "transparent",
                              shadow: "0 0 0 3px var(--focusColor)",
                            }}
                            w="fit-content"
                            minW="fit-content"
                            bg="transparent"
                            // disabled={!ownerProfile}
                          >
                            @username
                          </Button> */}
                        </Skeleton>
                      </Td>
                      <Td>
                        <Skeleton isLoaded={status !== "fetching"}>
                          {trade?.createdAt &&
                            format(parseISO(trade?.createdAt), "PP HH:mm")}
                        </Skeleton>
                      </Td>
                      <Td>
                        <Skeleton isLoaded={status !== "fetching"}>
                          {toUpper(trade?.adsType ?? "")}
                        </Skeleton>
                      </Td>
                      <Td>
                        <Skeleton isLoaded={status !== "fetching"}>
                          {/* {console.log("CURRENCY", getCurrency(trade))} */}
                          {trade?.fiat &&
                            formatter(trade?.fiat).format(trade?.amount ?? 0)}
                        </Skeleton>
                      </Td>
                      <Td fontWeight="bold">
                        <Skeleton isLoaded={status !== "fetching"}>
                          {trade?.volume &&
                            toPrecision(
                              parseFloat(trade.volume) ?? 0,
                              trade?.token
                            )}
                          {/* {toUpper(trade?.token ?? "")} */}
                        </Skeleton>
                      </Td>
                      <Td>
                        <Skeleton isLoaded={status !== "fetching"}>
                          {trade?.contractState &&
                            statusMap(
                              String(trade.contractState).toLowerCase()
                            )}
                        </Skeleton>
                      </Td>

                      <Td>
                        <Skeleton isLoaded={status !== "fetching"}>
                          <Button
                            // disabled={trade?.contractState === "closed"}
                            _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
                            onClick={() => {
                              // console.log("TRADE", trade);
                              if (
                                trade?.tradeRef &&
                                trade?.contractState !== "closed"
                              ) {
                                history.push(
                                  `/dashboard/p2p/trades/session/${trade.tradeRef}`
                                );
                              } else {
                                history.push(
                                  `/dashboard/p2p/trades/completed/${trade._id}`
                                );
                              }
                            }}
                            variant="link"
                          >
                            Details
                          </Button>
                        </Skeleton>
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
              {/* )} */}

              {isEmpty(data) && status !== "fetching" && <NoData />}

              {isEmpty(data) && status === "fetching" && (
                <Table
                  variant="solid"
                  colorScheme="teal"
                  bg="white"
                  // borderRadius="16px"
                  border="1px solid #D9DBE95f"
                  overflow="hidden"
                >
                  <Tbody>
                    {Array(2)
                      .fill(0)
                      .map(() => (
                        <Tr>
                          <Td>
                            <Skeleton>Something</Skeleton>
                          </Td>
                          <Td>
                            <Skeleton>Something</Skeleton>
                          </Td>
                          <Td>
                            <Skeleton>Something</Skeleton>
                          </Td>
                          <Td>
                            <Skeleton>Something</Skeleton>
                          </Td>
                          <Td>
                            <Skeleton>Something</Skeleton>
                          </Td>
                          <Td>
                            <Skeleton>Something</Skeleton>
                          </Td>
                        </Tr>
                      ))}
                  </Tbody>
                </Table>
              )}

              <Stack d={["flex", "flex", "none"]} flexDir="column">
                {data.map((trade, i) => (
                  <Box p="10px 28px" bg="white">
                    <Skeleton isLoaded={status !== "fetching"} maxW="100px">
                      <Text color="#3151AB">{toUpper(trade.token)}</Text>
                    </Skeleton>
                    <HStack justifyContent="space-between" mt="8px">
                      <Skeleton isLoaded={status !== "fetching"}>
                        <HStack>
                          <Text fontSize="xs" color="#4E4B66">
                            Date
                          </Text>
                          <Text fontSize="sm" fontWeight="500">
                            {trade?.createdAt &&
                              format(parseISO(trade?.createdAt), "PP HH:mm")}
                          </Text>
                        </HStack>
                      </Skeleton>
                      <Skeleton isLoaded={status !== "fetching"}>
                        <HStack>
                          <Text fontSize="xs" color="#4E4B66">
                            Amount
                          </Text>
                          <Text fontSize="sm" fontWeight="500">
                            {trade?.fiat &&
                              formatter(trade?.fiat).format(trade?.amount ?? 0)}
                          </Text>
                        </HStack>
                      </Skeleton>
                    </HStack>
                    <HStack justifyContent="space-between" mt="4px">
                      <Skeleton isLoaded={status !== "fetching"}>
                        <HStack>
                          <Text fontSize="xs" color="#4E4B66">
                            Quantity
                          </Text>
                          <Text fontSize="sm" fontWeight="500">
                            {trade?.volume &&
                              toPrecision(
                                parseFloat(trade.volume) ?? 0,
                                trade?.token
                              )}
                            {/* {toUpper(trade?.token ?? "")} */}
                          </Text>
                        </HStack>
                      </Skeleton>
                      <Skeleton isLoaded={status !== "fetching"}>
                        <HStack>
                          <Text fontSize="xs" color="#4E4B66">
                            Status
                          </Text>
                          <Text fontSize="sm" fontWeight="500">
                            {trade?.contractState &&
                              statusMap(
                                String(trade.contractState).toLowerCase()
                              )}
                          </Text>
                        </HStack>
                      </Skeleton>
                    </HStack>

                    <Skeleton
                      isLoaded={status !== "fetching"}
                      maxW="80px"
                      maxH="24px"
                      mt="20px"
                    >
                      <Button
                        // disabled={trade?.contractState === "closed"}
                        fontSize="sm"
                        _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
                        onClick={() => {
                          // console.log("TRADE", trade);
                          if (
                            trade?.tradeRef &&
                            trade?.contractState !== "closed"
                          ) {
                            history.push(
                              `/dashboard/p2p/trades/session/${trade.tradeRef}`
                            );
                          } else {
                            history.push(
                              `/dashboard/p2p/trades/completed/${trade._id}`
                            );
                          }
                        }}
                        variant="link"
                      >
                        Details
                      </Button>
                    </Skeleton>
                  </Box>
                ))}
              </Stack>
              <HStack
                mt={["20px", "20px", "0"]}
                bg={["transparent", "transparent", "white"]}
                p="10px 40px"
                justifyContent="space-between"
                borderRadius="0px 0px 16px 16px"
                // d={["none", "none", "flex"]}
                flexDir={["column", "column", "row"]}
              >
                <Text>
                  Showing {offset + 1} to {clamp(offset + 10, 10, count)} of{" "}
                  {count}
                </Text>
                <HStack>
                  <Pagination
                    pagesCount={pagesCount}
                    currentPage={currentPage}
                    isDisabled={isDisabled}
                    onPageChange={handlePageChange}
                  >
                    <PaginationContainer
                      align="center"
                      justify="space-between"
                      p={4}
                      w="full"
                    >
                      <PaginationPrevious
                        mr="8px"
                        boxSize="32px"
                        _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
                        _active={{ bg: "transparent" }}
                        _hover={{
                          bg: "transparent",
                        }}
                        bg="transparent"
                      >
                        <ChevronLeftIcon />
                      </PaginationPrevious>
                      <PaginationPageGroup
                        isInline
                        align="center"
                        separator={
                          <PaginationSeparator
                            border="1px solid #DFE3E8"
                            bg="transparent"
                            fontSize="sm"
                            boxSize="32px"
                            jumpSize={4}
                            _active={{ bg: "transparent" }}
                            _hover={{
                              bg: "transparent",
                            }}
                            _focus={{
                              borderColor: "transparent",
                              shadow: "0 0 0 3px var(--focusColor)",
                            }}
                          />
                        }
                      >
                        {pages.map((page) => (
                          <PaginationPage
                            boxSize="32px"
                            bg="transparent"
                            border="1px solid #DFE3E8"
                            key={`pagination_page_${page}`}
                            page={page}
                            fontSize="sm"
                            _active={{ bg: "transparent" }}
                            _hover={{
                              bg: "transparent",
                            }}
                            _focus={{
                              borderColor: "transparent",
                              shadow: "0 0 0 3px var(--focusColor)",
                            }}
                            _current={{
                              borderColor: "transparent",
                              bg: "#03a438",
                              fontSize: "sm",
                              boxSize: "32px",
                              color: "white",
                              _hover: {
                                borderColor: "#DFE3E8",
                                bg: "transparent",
                                color: "black",
                              },
                            }}
                          />
                        ))}
                      </PaginationPageGroup>
                      <PaginationNext
                        ml="8px"
                        boxSize="32px"
                        _active={{ bg: "transparent" }}
                        _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
                        _hover={{
                          bg: "transparent",
                        }}
                        bg="transparent"
                      >
                        <ChevronRightIcon />
                      </PaginationNext>
                    </PaginationContainer>
                  </Pagination>
                </HStack>
              </HStack>
            </Box>
          </Container>
        </Box>
      </Box>

      <DownloadTradeHistory isOpen={isOpen} onClose={onClose} />
    </Box>
  );
};

export default TradeHistory;
